export default "__VITE_ASSET__B9Vjfm67__"